
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AdminBulkCreateRewardsUserResult": [
      "AdminBulkCreateRewardsUserError",
      "AdminBulkCreateRewardsUserSuccess"
    ],
    "AdminGoalDetails": [
      "TimeToFirstShiftAdminGoalDetails"
    ],
    "AdminGoalRewards": [
      "AdminGoalRewardsGiftCard",
      "AdminGoalRewardsPayroll",
      "AdminGoalRewardsNoReward"
    ],
    "AdminGoalTarget": [
      "AdminGoalTargetPercentage",
      "AdminGoalTargetTimeToFirstShift"
    ],
    "AdminGoalTracker": [
      "BudgetUtilizationAdminGoalTracker",
      "LoginAdminGoalTracker",
      "TimeToFirstShiftAdminGoalTracker"
    ],
    "BaseBudgetPeriodSummary": [
      "AdminShiftRewardBudgetPeriodSummary"
    ],
    "BaseCaregiverImpactMonthDistinctionSlideContent": [
      "CaregiverImpactLifesaverDistinctionSlide",
      "CaregiverImpactReliableHeroDistinctionSlide",
      "CaregiverImpactWeekendShiftWarriorDistinctionSlide"
    ],
    "BaseDraw": [
      "CaribouSponsoredDraw",
      "Draw"
    ],
    "BaseDrawPrize": [
      "DrawPrizePoints",
      "DrawTieredPrizePoints"
    ],
    "BaseDrawPrizeStructure": [
      "DrawPrizeStructureSinglePrizeMultipleWinners",
      "DrawPrizeStructureTieredPrizesMultipleWinners"
    ],
    "BasePHIAgentTimelineItem": [
      "PHIAgentTimelineItemAction",
      "PHIAgentTimelineItemEscalation",
      "PHIAgentTimelineItemPrompt",
      "PHIAgentTimelineItemWaiting"
    ],
    "CandidateNextStepFilterOption": [
      "CandidateRecruitmentStepFilterOption",
      "CandidateMonthlyRetentionStepFilterOption",
      "CandidateHourlyRetentionStepFilterOption"
    ],
    "CandidateStep": [
      "CandidateRecruitmentStep",
      "CandidateRetentionStep"
    ],
    "CandidateStepV2": [
      "CandidateRecruitmentStep",
      "CandidateMonthlyRetentionStep",
      "CandidateHourlyRetentionStep"
    ],
    "CaregiverImpactMonthSlideContent": [
      "CaregiverImpactLifesaverDistinctionSlide",
      "CaregiverImpactWeekendShiftWarriorDistinctionSlide",
      "CaregiverImpactReliableHeroDistinctionSlide"
    ],
    "CaregiverProfileTravelDistance": [
      "CaregiverProfileTravelDistanceMinutes"
    ],
    "CaregiverProfileWorkingLanguage": [
      "CaregiverProfileWorkingLanguagePredefined",
      "CaregiverProfileWorkingLanguageCustom"
    ],
    "CategorizedTransactionMetadata": [
      "TransactionMetadataAnniversaryGoal",
      "TransactionMetadataBillableHoursIncrease",
      "TransactionMetadataBirthdayGoal",
      "TransactionMetadataCompleteCaregiverProfile",
      "TransactionMetadataDailyReward",
      "TransactionMetadataDrawWinner",
      "TransactionMetadataEVVPunchCard",
      "TransactionMetadataEVVStreakGoal",
      "TransactionMetadataLastMinuteShift",
      "TransactionMetadataMilestoneRewards",
      "TransactionMetadataMobileAppAdoption",
      "TransactionMetadataPointsRedeemed",
      "TransactionMetadataPointsRemoval",
      "TransactionMetadataRecognition",
      "TransactionMetadataRedemption",
      "TransactionMetadataRedemptionRejected",
      "TransactionMetadataReferralAssignedAsReferringEmployee",
      "TransactionMetadataReferralCorrection",
      "TransactionMetadataReferralJobShare",
      "TransactionMetadataReferralRecruitmentStep",
      "TransactionMetadataReferralRetentionMilestone",
      "TransactionMetadataShiftReward",
      "TransactionMetadataSurvey",
      "TransactionMetadataTrainingProgram",
      "TransactionMetadataUnknown",
      "TransactionMetadataWatchedVideo",
      "TransactionMetadataWeekendShift",
      "TransactionMetadataWelcomeGoal"
    ],
    "DailyRewardTracker": [
      "DailyRewardTrackerWatchVideo",
      "DailyRewardTrackerSocialPost",
      "DailyRewardTrackerCompleteCaregiverProfile",
      "DailyRewardTrackerReviewTopPicks",
      "DailyRewardTrackerAutomatedRecognition",
      "DailyRewardTrackerAvailabilityCheckIn"
    ],
    "DrawPrize": [
      "DrawPrizePoints",
      "DrawTieredPrizePoints"
    ],
    "DrawWayToEarn": [
      "DrawWayToEarnRewardOffer",
      "DrawWayToEarnShareJobs"
    ],
    "FirstShiftSurveyAverageInsightMetric": [
      "EligibleFirstShiftSurveyAverageInsightMetric",
      "IneligibleFirstShiftSurveyAverageInsightMetric"
    ],
    "FirstShiftSurveyResponseRateInsightMetric": [
      "EligibleFirstShiftSurveyResponseRateInsightMetric",
      "IneligibleFirstShiftSurveyResponseRateInsightMetric"
    ],
    "GoalDetails": [
      "SurveyGoalDetails",
      "WatchVideoGoalDetails",
      "CompleteTrainingGoalDetails",
      "ShiftRewardGoalDetails",
      "AnniversaryGoalDetails"
    ],
    "GoalTracker": [
      "JobShareGoalTracker",
      "SurveyGoalTracker",
      "EVVStreakGoalTracker",
      "WatchVideoGoalTracker",
      "HHAXLoginGoalTracker",
      "LastMinuteShiftGoalTracker",
      "CompleteTrainingGoalTracker",
      "WeekendShiftGoalTracker",
      "BillableHoursGoalTracker",
      "CompleteCaregiverProfileGoalTracker",
      "WelcomeGoalTracker",
      "ShiftRewardGoalTracker",
      "BirthdayGoalTracker",
      "AnniversaryGoalTracker"
    ],
    "GoalUnlockCriteria": [
      "DependingGoalUnlockCriteria",
      "TimeBasedlUnlockCriteria"
    ],
    "HHAXLoginGoalTrackerLoginCompletionData": [
      "HHAXLoginGoalTrackerLoginCompletionDataV1"
    ],
    "InsightDateRanges": [
      "LaunchedInsightDateRanges",
      "NotLaunchedInsightDateRanges"
    ],
    "JobPostingApplicationField": [
      "JobPostingSystemRequiredField",
      "JobPostingSystemMaybeOptionalField",
      "JobPostingYesNoField"
    ],
    "JobPostingFieldInterface": [
      "JobPostingSystemMaybeOptionalField",
      "JobPostingSystemRequiredField",
      "JobPostingYesNoField"
    ],
    "MailingAddress": [
      "CAMailingAddress",
      "USMailingAddress"
    ],
    "MilestoneGoal": [
      "VisitMilestoneGoal",
      "HoursMilestoneGoal"
    ],
    "MilestoneRewardsBackfillConfig": [
      "MilestoneRewardsDisableBackfillConfig",
      "MilestoneRewardsEnableBackfillConfig"
    ],
    "NonPHIShiftPostingCard": [
      "NonPHIShiftPostingCardPermanent",
      "NonPHIShiftPostingCardTemporary"
    ],
    "NonPHIShiftPostingCardBase": [
      "NonPHIShiftPosting",
      "NonPHIShiftPostingCardPermanent",
      "NonPHIShiftPostingCardTemporary"
    ],
    "NumActiveCandidatesByJobPostingAndNextStepItemTotal": [
      "NumActiveCandidatesByJobPostingAndNextStepItemTotalRecruitment",
      "NumActiveCandidatesByJobPostingAndNextStepItemTotalRetention"
    ],
    "NumActiveCandidatesByJobPostingAndStatusItemTotal": [
      "NumActiveCandidatesByJobPostingAndStatusItemTotalRecruitment",
      "NumActiveCandidatesByJobPostingAndStatusItemTotalRetention"
    ],
    "PHIAgentDetails": [
      "PHIAgentActionDetailsBroadcastSMSForInterest",
      "PHIAgentActionDetailsBroadcastCallsForInterest",
      "PHIAgentActionDetailsUpdatePatientDetails",
      "PHIAgentActionDetailsMarkCaregiverConfirmedForShifts",
      "PHIAgentActionDetailsToggleShowShiftsToCaregivers",
      "PHIAgentActionDetailsAssignTemporaryShiftsToCaregiver",
      "PHIAgentActionDetailsRecordCaregiverMemory"
    ],
    "PHIAgentTimelineItem": [
      "PHIAgentTimelineItemPrompt",
      "PHIAgentTimelineItemAction",
      "PHIAgentTimelineItemEscalation",
      "PHIAgentTimelineItemWaiting"
    ],
    "PointTransactionReason": [
      "PointTransactionAwardedAssignedAsCandidateReferrerReason",
      "PointTransactionAwardedCustomPointsAwardedReason",
      "PointTransactionAwardedDailyRewardAchievedReason",
      "PointTransactionAwardedDrawPrizeWinnerReason",
      "PointTransactionAwardedJobPostingSharedReason",
      "PointTransactionAwardedOptInReason",
      "PointTransactionAwardedRecognitionPointsReason",
      "PointTransactionAwardedReferralAppliedReason",
      "PointTransactionAwardedReferralCompletedFirstShiftReason",
      "PointTransactionAwardedReferralCompletedOrientationReason",
      "PointTransactionAwardedReferralHiredReason",
      "PointTransactionAwardedReferralPassedInterviewReason",
      "PointTransactionAwardedReferralReachedHourlyRetentionMilestoneReason",
      "PointTransactionAwardedReferralReachedRetentionMilestoneReason",
      "PointTransactionAwardedReferralStartedOrientationReason",
      "PointTransactionAwardedRewardOfferCompletedReason",
      "PointTransactionAwardedShiftMilestoneCompletedReason",
      "PointTransactionAwardedWelcomeOfferCompletedReason",
      "PointTransactionDeductedCustomPointsDeductedReason",
      "PointTransactionDeductedDuplicateReferralReason",
      "PointTransactionDeductedHourlyRetentionMilestoneReversedReason",
      "PointTransactionDeductedRecruitmentStepReversedReason",
      "PointTransactionDeductedRetentionMilestoneReversedReason",
      "PointTransactionDeductedUnassignedAsCandidateReferrerReason",
      "PointTransactionFraudulentCandidateArchivedReason",
      "PointTransactionGoalAchievedReason"
    ],
    "PointsByCategoryAndMonthTableInsightMetric": [
      "LaunchedPointsByCategoryAndMonthTableInsightMetric",
      "NotLaunchedPointsByCategoryAndMonthTableInsightMetric"
    ],
    "PowerHoursHourCondition": [
      "PowerHoursWeekendHoursCondition"
    ],
    "RecordedCandidateStep": [
      "RecordedCandidateRecruitmentStep",
      "RecordedCandidateRetentionStep"
    ],
    "RecordedCandidateStepV2": [
      "RecordedCandidateRecruitmentStep",
      "RecordedCandidateMonthlyRetentionStep",
      "RecordedCandidateHourlyRetentionStep"
    ],
    "RedemptionCatalogItemPrice": [
      "RedemptionCatalogItemFixedPrice",
      "RedemptionCatalogItemMultipleValuesPrice"
    ],
    "RedemptionCatalogItemProvider": [
      "RedemptionCatalogItemTangoProvider",
      "RedemptionCatalogItemSnappyProvider"
    ],
    "ReferralHoursWorkedInsightMetric": [
      "EligibleReferralHoursWorkedInsightMetric",
      "IneligibleReferralHoursWorkedInsightMetric"
    ],
    "ReferralRewardStructureItem": [
      "ReferralRewardStructureJobShareItem",
      "ReferralRewardStructureReferralRecruitmentItem",
      "ReferralRewardStructureReferralRetentionItem"
    ],
    "ReferralRewardStructureReward": [
      "ReferralRewardStructurePointReward",
      "ReferralRewardStructureDrawTicketReward",
      "ReferralRewardStructureManualMonthlyRaffleReward"
    ],
    "ReferralRewardStructureStepItem": [
      "ReferralRewardStructureReferralRecruitmentItem",
      "ReferralRewardStructureReferralRetentionItem"
    ],
    "RetoolShiftPostingMatch": [
      "RetoolTemporaryShiftPostingMatch",
      "RetoolPermanentShiftPostingMatch"
    ],
    "RetoolShiftPostingMatchBase": [
      "RetoolPermanentShiftPostingMatch",
      "RetoolTemporaryShiftPostingMatch"
    ],
    "RewardOfferAction": [
      "RewardOfferModalAction",
      "RewardOfferInAppLinkAction",
      "RewardOfferExternalLinkAction"
    ],
    "RewardOfferStructure": [
      "RewardOfferStructureUnlimited",
      "RewardOfferStructureOneTime",
      "RewardOfferStructurePeriodic",
      "RewardOfferStructureDiscreteProgress",
      "RewardOfferStructurePunchCard"
    ],
    "RewardOfferStructureReward": [
      "RewardOfferNextReward",
      "RewardOfferStructureDiscreteProgressStep",
      "RewardOfferStructureOneTime",
      "RewardOfferStructurePeriodic",
      "RewardOfferStructurePunchCard",
      "RewardOfferStructureUnlimited"
    ],
    "RewardVideoFile": [
      "RewardVideoUrlFile",
      "RewardVideoManagedFile"
    ],
    "RewardsAdminPermissions": [
      "RewardsAdminFullAccessPermissions",
      "RewardsAdminRestrictedAccessPermissions"
    ],
    "RewardsGroupTagsConfig": [
      "RewardsGroupTagsConfigSchemaV1"
    ],
    "RewardsUserAddress": [
      "RewardsUserCAAddress",
      "RewardsUserUSAddress"
    ],
    "RewardsUserIdentity": [
      "RewardsAdminUser",
      "RewardsUser"
    ],
    "RewardsUserPersonalContactInfo": [
      "RewardsUserPersonalContactInfoData",
      "RewardsUserPersonalContactInfoSuppressed"
    ],
    "SocialPostDetails": [
      "CustomSocialPostDetails",
      "BirthdaySocialPostDetails",
      "WorkMilestoneSocialPostDetails",
      "RedemptionSocialPostDetails"
    ],
    "TimeToFirstShiftInsightMetric": [
      "EligibleTimeToFirstShiftInsightMetric",
      "IneligibleTimeToFirstShiftInsightMetric"
    ],
    "TransactionMetadata": [
      "TransactionMetadataUnknown",
      "TransactionMetadataReferralJobShare",
      "TransactionMetadataReferralRecruitmentStep",
      "TransactionMetadataReferralRetentionMilestone",
      "TransactionMetadataReferralAssignedAsReferringEmployee",
      "TransactionMetadataReferralCorrection",
      "TransactionMetadataRecognition",
      "TransactionMetadataEVVStreakGoal",
      "TransactionMetadataEVVPunchCard",
      "TransactionMetadataMobileAppAdoption",
      "TransactionMetadataMilestoneRewards",
      "TransactionMetadataSurvey",
      "TransactionMetadataWeekendShift",
      "TransactionMetadataLastMinuteShift",
      "TransactionMetadataWatchedVideo",
      "TransactionMetadataTrainingProgram",
      "TransactionMetadataBillableHoursIncrease",
      "TransactionMetadataRedemption",
      "TransactionMetadataRedemptionRejected",
      "TransactionMetadataDrawWinner",
      "TransactionMetadataCompleteCaregiverProfile",
      "TransactionMetadataWelcomeGoal",
      "TransactionMetadataShiftReward",
      "TransactionMetadataBirthdayGoal",
      "TransactionMetadataAnniversaryGoal",
      "TransactionMetadataPointsRemoval",
      "TransactionMetadataPointsRedeemed",
      "TransactionMetadataDailyReward"
    ],
    "WorkMilestoneSocialPostMilestone": [
      "WorkMilestoneSocialPostMilestoneVisit",
      "WorkMilestoneSocialPostMilestoneHours"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdminBulkCreateRewardsUserResult": [
      "AdminBulkCreateRewardsUserError",
      "AdminBulkCreateRewardsUserSuccess"
    ],
    "AdminGoalDetails": [
      "TimeToFirstShiftAdminGoalDetails"
    ],
    "AdminGoalRewards": [
      "AdminGoalRewardsGiftCard",
      "AdminGoalRewardsPayroll",
      "AdminGoalRewardsNoReward"
    ],
    "AdminGoalTarget": [
      "AdminGoalTargetPercentage",
      "AdminGoalTargetTimeToFirstShift"
    ],
    "AdminGoalTracker": [
      "BudgetUtilizationAdminGoalTracker",
      "LoginAdminGoalTracker",
      "TimeToFirstShiftAdminGoalTracker"
    ],
    "BaseBudgetPeriodSummary": [
      "AdminShiftRewardBudgetPeriodSummary"
    ],
    "BaseCaregiverImpactMonthDistinctionSlideContent": [
      "CaregiverImpactLifesaverDistinctionSlide",
      "CaregiverImpactReliableHeroDistinctionSlide",
      "CaregiverImpactWeekendShiftWarriorDistinctionSlide"
    ],
    "BaseDraw": [
      "CaribouSponsoredDraw",
      "Draw"
    ],
    "BaseDrawPrize": [
      "DrawPrizePoints",
      "DrawTieredPrizePoints"
    ],
    "BaseDrawPrizeStructure": [
      "DrawPrizeStructureSinglePrizeMultipleWinners",
      "DrawPrizeStructureTieredPrizesMultipleWinners"
    ],
    "BasePHIAgentTimelineItem": [
      "PHIAgentTimelineItemAction",
      "PHIAgentTimelineItemEscalation",
      "PHIAgentTimelineItemPrompt",
      "PHIAgentTimelineItemWaiting"
    ],
    "CandidateNextStepFilterOption": [
      "CandidateRecruitmentStepFilterOption",
      "CandidateMonthlyRetentionStepFilterOption",
      "CandidateHourlyRetentionStepFilterOption"
    ],
    "CandidateStep": [
      "CandidateRecruitmentStep",
      "CandidateRetentionStep"
    ],
    "CandidateStepV2": [
      "CandidateRecruitmentStep",
      "CandidateMonthlyRetentionStep",
      "CandidateHourlyRetentionStep"
    ],
    "CaregiverImpactMonthSlideContent": [
      "CaregiverImpactLifesaverDistinctionSlide",
      "CaregiverImpactWeekendShiftWarriorDistinctionSlide",
      "CaregiverImpactReliableHeroDistinctionSlide"
    ],
    "CaregiverProfileTravelDistance": [
      "CaregiverProfileTravelDistanceMinutes"
    ],
    "CaregiverProfileWorkingLanguage": [
      "CaregiverProfileWorkingLanguagePredefined",
      "CaregiverProfileWorkingLanguageCustom"
    ],
    "CategorizedTransactionMetadata": [
      "TransactionMetadataAnniversaryGoal",
      "TransactionMetadataBillableHoursIncrease",
      "TransactionMetadataBirthdayGoal",
      "TransactionMetadataCompleteCaregiverProfile",
      "TransactionMetadataDailyReward",
      "TransactionMetadataDrawWinner",
      "TransactionMetadataEVVPunchCard",
      "TransactionMetadataEVVStreakGoal",
      "TransactionMetadataLastMinuteShift",
      "TransactionMetadataMilestoneRewards",
      "TransactionMetadataMobileAppAdoption",
      "TransactionMetadataPointsRedeemed",
      "TransactionMetadataPointsRemoval",
      "TransactionMetadataRecognition",
      "TransactionMetadataRedemption",
      "TransactionMetadataRedemptionRejected",
      "TransactionMetadataReferralAssignedAsReferringEmployee",
      "TransactionMetadataReferralCorrection",
      "TransactionMetadataReferralJobShare",
      "TransactionMetadataReferralRecruitmentStep",
      "TransactionMetadataReferralRetentionMilestone",
      "TransactionMetadataShiftReward",
      "TransactionMetadataSurvey",
      "TransactionMetadataTrainingProgram",
      "TransactionMetadataUnknown",
      "TransactionMetadataWatchedVideo",
      "TransactionMetadataWeekendShift",
      "TransactionMetadataWelcomeGoal"
    ],
    "DailyRewardTracker": [
      "DailyRewardTrackerWatchVideo",
      "DailyRewardTrackerSocialPost",
      "DailyRewardTrackerCompleteCaregiverProfile",
      "DailyRewardTrackerReviewTopPicks",
      "DailyRewardTrackerAutomatedRecognition",
      "DailyRewardTrackerAvailabilityCheckIn"
    ],
    "DrawPrize": [
      "DrawPrizePoints",
      "DrawTieredPrizePoints"
    ],
    "DrawWayToEarn": [
      "DrawWayToEarnRewardOffer",
      "DrawWayToEarnShareJobs"
    ],
    "FirstShiftSurveyAverageInsightMetric": [
      "EligibleFirstShiftSurveyAverageInsightMetric",
      "IneligibleFirstShiftSurveyAverageInsightMetric"
    ],
    "FirstShiftSurveyResponseRateInsightMetric": [
      "EligibleFirstShiftSurveyResponseRateInsightMetric",
      "IneligibleFirstShiftSurveyResponseRateInsightMetric"
    ],
    "GoalDetails": [
      "SurveyGoalDetails",
      "WatchVideoGoalDetails",
      "CompleteTrainingGoalDetails",
      "ShiftRewardGoalDetails",
      "AnniversaryGoalDetails"
    ],
    "GoalTracker": [
      "JobShareGoalTracker",
      "SurveyGoalTracker",
      "EVVStreakGoalTracker",
      "WatchVideoGoalTracker",
      "HHAXLoginGoalTracker",
      "LastMinuteShiftGoalTracker",
      "CompleteTrainingGoalTracker",
      "WeekendShiftGoalTracker",
      "BillableHoursGoalTracker",
      "CompleteCaregiverProfileGoalTracker",
      "WelcomeGoalTracker",
      "ShiftRewardGoalTracker",
      "BirthdayGoalTracker",
      "AnniversaryGoalTracker"
    ],
    "GoalUnlockCriteria": [
      "DependingGoalUnlockCriteria",
      "TimeBasedlUnlockCriteria"
    ],
    "HHAXLoginGoalTrackerLoginCompletionData": [
      "HHAXLoginGoalTrackerLoginCompletionDataV1"
    ],
    "InsightDateRanges": [
      "LaunchedInsightDateRanges",
      "NotLaunchedInsightDateRanges"
    ],
    "JobPostingApplicationField": [
      "JobPostingSystemRequiredField",
      "JobPostingSystemMaybeOptionalField",
      "JobPostingYesNoField"
    ],
    "JobPostingFieldInterface": [
      "JobPostingSystemMaybeOptionalField",
      "JobPostingSystemRequiredField",
      "JobPostingYesNoField"
    ],
    "MailingAddress": [
      "CAMailingAddress",
      "USMailingAddress"
    ],
    "MilestoneGoal": [
      "VisitMilestoneGoal",
      "HoursMilestoneGoal"
    ],
    "MilestoneRewardsBackfillConfig": [
      "MilestoneRewardsDisableBackfillConfig",
      "MilestoneRewardsEnableBackfillConfig"
    ],
    "NonPHIShiftPostingCard": [
      "NonPHIShiftPostingCardPermanent",
      "NonPHIShiftPostingCardTemporary"
    ],
    "NonPHIShiftPostingCardBase": [
      "NonPHIShiftPosting",
      "NonPHIShiftPostingCardPermanent",
      "NonPHIShiftPostingCardTemporary"
    ],
    "NumActiveCandidatesByJobPostingAndNextStepItemTotal": [
      "NumActiveCandidatesByJobPostingAndNextStepItemTotalRecruitment",
      "NumActiveCandidatesByJobPostingAndNextStepItemTotalRetention"
    ],
    "NumActiveCandidatesByJobPostingAndStatusItemTotal": [
      "NumActiveCandidatesByJobPostingAndStatusItemTotalRecruitment",
      "NumActiveCandidatesByJobPostingAndStatusItemTotalRetention"
    ],
    "PHIAgentDetails": [
      "PHIAgentActionDetailsBroadcastSMSForInterest",
      "PHIAgentActionDetailsBroadcastCallsForInterest",
      "PHIAgentActionDetailsUpdatePatientDetails",
      "PHIAgentActionDetailsMarkCaregiverConfirmedForShifts",
      "PHIAgentActionDetailsToggleShowShiftsToCaregivers",
      "PHIAgentActionDetailsAssignTemporaryShiftsToCaregiver",
      "PHIAgentActionDetailsRecordCaregiverMemory"
    ],
    "PHIAgentTimelineItem": [
      "PHIAgentTimelineItemPrompt",
      "PHIAgentTimelineItemAction",
      "PHIAgentTimelineItemEscalation",
      "PHIAgentTimelineItemWaiting"
    ],
    "PointTransactionReason": [
      "PointTransactionAwardedAssignedAsCandidateReferrerReason",
      "PointTransactionAwardedCustomPointsAwardedReason",
      "PointTransactionAwardedDailyRewardAchievedReason",
      "PointTransactionAwardedDrawPrizeWinnerReason",
      "PointTransactionAwardedJobPostingSharedReason",
      "PointTransactionAwardedOptInReason",
      "PointTransactionAwardedRecognitionPointsReason",
      "PointTransactionAwardedReferralAppliedReason",
      "PointTransactionAwardedReferralCompletedFirstShiftReason",
      "PointTransactionAwardedReferralCompletedOrientationReason",
      "PointTransactionAwardedReferralHiredReason",
      "PointTransactionAwardedReferralPassedInterviewReason",
      "PointTransactionAwardedReferralReachedHourlyRetentionMilestoneReason",
      "PointTransactionAwardedReferralReachedRetentionMilestoneReason",
      "PointTransactionAwardedReferralStartedOrientationReason",
      "PointTransactionAwardedRewardOfferCompletedReason",
      "PointTransactionAwardedShiftMilestoneCompletedReason",
      "PointTransactionAwardedWelcomeOfferCompletedReason",
      "PointTransactionDeductedCustomPointsDeductedReason",
      "PointTransactionDeductedDuplicateReferralReason",
      "PointTransactionDeductedHourlyRetentionMilestoneReversedReason",
      "PointTransactionDeductedRecruitmentStepReversedReason",
      "PointTransactionDeductedRetentionMilestoneReversedReason",
      "PointTransactionDeductedUnassignedAsCandidateReferrerReason",
      "PointTransactionFraudulentCandidateArchivedReason",
      "PointTransactionGoalAchievedReason"
    ],
    "PointsByCategoryAndMonthTableInsightMetric": [
      "LaunchedPointsByCategoryAndMonthTableInsightMetric",
      "NotLaunchedPointsByCategoryAndMonthTableInsightMetric"
    ],
    "PowerHoursHourCondition": [
      "PowerHoursWeekendHoursCondition"
    ],
    "RecordedCandidateStep": [
      "RecordedCandidateRecruitmentStep",
      "RecordedCandidateRetentionStep"
    ],
    "RecordedCandidateStepV2": [
      "RecordedCandidateRecruitmentStep",
      "RecordedCandidateMonthlyRetentionStep",
      "RecordedCandidateHourlyRetentionStep"
    ],
    "RedemptionCatalogItemPrice": [
      "RedemptionCatalogItemFixedPrice",
      "RedemptionCatalogItemMultipleValuesPrice"
    ],
    "RedemptionCatalogItemProvider": [
      "RedemptionCatalogItemTangoProvider",
      "RedemptionCatalogItemSnappyProvider"
    ],
    "ReferralHoursWorkedInsightMetric": [
      "EligibleReferralHoursWorkedInsightMetric",
      "IneligibleReferralHoursWorkedInsightMetric"
    ],
    "ReferralRewardStructureItem": [
      "ReferralRewardStructureJobShareItem",
      "ReferralRewardStructureReferralRecruitmentItem",
      "ReferralRewardStructureReferralRetentionItem"
    ],
    "ReferralRewardStructureReward": [
      "ReferralRewardStructurePointReward",
      "ReferralRewardStructureDrawTicketReward",
      "ReferralRewardStructureManualMonthlyRaffleReward"
    ],
    "ReferralRewardStructureStepItem": [
      "ReferralRewardStructureReferralRecruitmentItem",
      "ReferralRewardStructureReferralRetentionItem"
    ],
    "RetoolShiftPostingMatch": [
      "RetoolTemporaryShiftPostingMatch",
      "RetoolPermanentShiftPostingMatch"
    ],
    "RetoolShiftPostingMatchBase": [
      "RetoolPermanentShiftPostingMatch",
      "RetoolTemporaryShiftPostingMatch"
    ],
    "RewardOfferAction": [
      "RewardOfferModalAction",
      "RewardOfferInAppLinkAction",
      "RewardOfferExternalLinkAction"
    ],
    "RewardOfferStructure": [
      "RewardOfferStructureUnlimited",
      "RewardOfferStructureOneTime",
      "RewardOfferStructurePeriodic",
      "RewardOfferStructureDiscreteProgress",
      "RewardOfferStructurePunchCard"
    ],
    "RewardOfferStructureReward": [
      "RewardOfferNextReward",
      "RewardOfferStructureDiscreteProgressStep",
      "RewardOfferStructureOneTime",
      "RewardOfferStructurePeriodic",
      "RewardOfferStructurePunchCard",
      "RewardOfferStructureUnlimited"
    ],
    "RewardVideoFile": [
      "RewardVideoUrlFile",
      "RewardVideoManagedFile"
    ],
    "RewardsAdminPermissions": [
      "RewardsAdminFullAccessPermissions",
      "RewardsAdminRestrictedAccessPermissions"
    ],
    "RewardsGroupTagsConfig": [
      "RewardsGroupTagsConfigSchemaV1"
    ],
    "RewardsUserAddress": [
      "RewardsUserCAAddress",
      "RewardsUserUSAddress"
    ],
    "RewardsUserIdentity": [
      "RewardsAdminUser",
      "RewardsUser"
    ],
    "RewardsUserPersonalContactInfo": [
      "RewardsUserPersonalContactInfoData",
      "RewardsUserPersonalContactInfoSuppressed"
    ],
    "SocialPostDetails": [
      "CustomSocialPostDetails",
      "BirthdaySocialPostDetails",
      "WorkMilestoneSocialPostDetails",
      "RedemptionSocialPostDetails"
    ],
    "TimeToFirstShiftInsightMetric": [
      "EligibleTimeToFirstShiftInsightMetric",
      "IneligibleTimeToFirstShiftInsightMetric"
    ],
    "TransactionMetadata": [
      "TransactionMetadataUnknown",
      "TransactionMetadataReferralJobShare",
      "TransactionMetadataReferralRecruitmentStep",
      "TransactionMetadataReferralRetentionMilestone",
      "TransactionMetadataReferralAssignedAsReferringEmployee",
      "TransactionMetadataReferralCorrection",
      "TransactionMetadataRecognition",
      "TransactionMetadataEVVStreakGoal",
      "TransactionMetadataEVVPunchCard",
      "TransactionMetadataMobileAppAdoption",
      "TransactionMetadataMilestoneRewards",
      "TransactionMetadataSurvey",
      "TransactionMetadataWeekendShift",
      "TransactionMetadataLastMinuteShift",
      "TransactionMetadataWatchedVideo",
      "TransactionMetadataTrainingProgram",
      "TransactionMetadataBillableHoursIncrease",
      "TransactionMetadataRedemption",
      "TransactionMetadataRedemptionRejected",
      "TransactionMetadataDrawWinner",
      "TransactionMetadataCompleteCaregiverProfile",
      "TransactionMetadataWelcomeGoal",
      "TransactionMetadataShiftReward",
      "TransactionMetadataBirthdayGoal",
      "TransactionMetadataAnniversaryGoal",
      "TransactionMetadataPointsRemoval",
      "TransactionMetadataPointsRedeemed",
      "TransactionMetadataDailyReward"
    ],
    "WorkMilestoneSocialPostMilestone": [
      "WorkMilestoneSocialPostMilestoneVisit",
      "WorkMilestoneSocialPostMilestoneHours"
    ]
  }
};
      export default result;
    